import { PERMANENT_ALEATOIRE } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case PERMANENT_ALEATOIRE.PERMANENT:
        return 'Permanent';
      case PERMANENT_ALEATOIRE.ALEATOIRE:
        return 'Aléatoire';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/filters/nature-dysfonctionnement.filter.js